import PageForm from 'components/pageForm/PageForm.js';
import ListBodyVivier from './components/content/body.list.vivier.js';

const ListAllVivier = () => (
  <PageForm>
    <ListBodyVivier />
  </PageForm>
);

export default ListAllVivier;
